export default __webpack_public_path__ + "static/media/4_active.004e76aa.png";